import React from 'react';
import ProductCard from './ProductCard'; // Наша универсальная карточка
import './ProductGrid.css'; // Его собственные стили

// ИЗМЕНЕНИЕ: Он теперь принимает пропсы и не имеет своей логики
const ProductGrid = ({ title, subtitle, products, onProductClick }) => {

    // Если по какой-то причине для этой категории нет товаров, мы просто ничего не рисуем
    if (!products || products.length === 0) {
        return null;
    }

    return (
        <section className="product-grid-section">
            <div className="section-header">
                {subtitle && <p className="section-subtitle">{subtitle}</p>}
                <h2 className="section-title">{title}</h2>
            </div>
            <div className="product-grid-container">
                {products.map((product) => (
                    <ProductCard
                        key={product.id}
                        product={product} // <-- Передаем ОДИН пропс, как договаривались
                        onCardClick={onProductClick} // onCardClick вместо onProductClick
                    />
                ))}
            </div>
        </section>
    );
};

export default ProductGrid;